import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/"
)({
  component: () => (
    <Navigate
      to="/organization-settings/general/$tabKey"
      params={{ tabKey: "details" }}
    />
  ),
})
